import {FC} from 'react'

import {Spinner} from '@/components/Spinner'
import {theme} from '@/theme/theme'
import {useEntityLogo} from '@/utils/data-fetchers/useEntityLogo'
import {LogoEntityType} from '@/utils/user-portal/types'

import {TrademarkLogoPreview} from '../trademark-preview/TrademarkLogoPreview'
import {Text, TextVariant} from './Text'

type EntityLogoProps = {
  logoEntityType: LogoEntityType
  entityId: string
  justify?: 'flex-start' | 'center' | 'flex-end'
  maxHeight?: string
  isPreviewEnabled?: boolean
  hasPreviewBorder?: boolean
  showMultiple?: boolean
  entityNameFallback?: string | null
}

export const EntityLogo: FC<EntityLogoProps> = ({
  logoEntityType,
  entityId,
  justify = 'center',
  maxHeight,
  isPreviewEnabled,
  hasPreviewBorder,
  showMultiple,
  entityNameFallback,
}) => {
  const {isLoading, data} = useEntityLogo(logoEntityType, entityId)

  return (
    <>
      {isLoading ? (
        <div className="spinner-wrapper">
          <Spinner color={theme.palette.text.default} />
        </div>
      ) : data ? (
        <TrademarkLogoPreview
          imageData={data}
          justify={justify}
          maxHeight={maxHeight}
          isPreviewEnabled={isPreviewEnabled}
          hasPreviewBorder={hasPreviewBorder}
          showMultiple={showMultiple}
        />
      ) : entityNameFallback ? (
        <Text
          variant={TextVariant.h5}
          element="span"
          align="center"
          className="text-block wrap-anywhere"
        >
          {entityNameFallback}
        </Text>
      ) : null}

      <style jsx>{`
        .spinner-wrapper {
          display: flex;
          align-items: center;
          justify-content: ${justify};
          width: 100%;
          height: 100%;
        }
      `}</style>
    </>
  )
}
